export var LightType = /* @__PURE__ */ ((LightType2) => {
  LightType2["AREA"] = "areaLight";
  LightType2["DIRECTIONAL"] = "directionalLight";
  LightType2["HEMISPHERE"] = "hemisphereLight";
  LightType2["POINT"] = "pointLight";
  LightType2["SPOT"] = "spotLight";
  return LightType2;
})(LightType || {});
export var THREELightType = /* @__PURE__ */ ((THREELightType2) => {
  THREELightType2["AREA"] = "AreaLight";
  THREELightType2["DIRECTIONAL"] = "DirectionalLight";
  THREELightType2["HEMISPHERE"] = "HemisphereLight";
  THREELightType2["POINT"] = "PointLight";
  THREELightType2["SPOT"] = "SpotLight";
  return THREELightType2;
})(THREELightType || {});
